import { Button } from "@chakra-ui/react";
import { icons } from "components/Icon/Icon.config";
import type { SbEditableComponentProps } from "types/storyblok";
import type { OpenChatButtonProps } from "./OpenChatButton.d";

export const OpenChatButton = ({
  icon = "Chat",
  buttonText,
  sbEditable,
}: SbEditableComponentProps<OpenChatButtonProps>) => {
  const Icon = icons[icon];

  const openChat = () => {
    window?.Chatbotize?.start();
  };

  return (
    <Button variant="link" fontSize="lg" onClick={openChat} {...sbEditable}>
      <Icon mr={2} />
      {buttonText}
    </Button>
  );
};
